export default {
    name: 'Associates',
    props: ['uuid'],

    data() {
        return {
            uuidAccount: '',
            associates: [],
            visible: false
        };
    },

    mounted() {
        this.uuidAccount = this.uuid;
        this.getAssociates();
    },

    methods: {
        toggleFunction() {
            this.visible = !this.visible;
            if (this.visible) this.getAssociates();
        },

        getAssociates() {
            this.$accountService
                .getAssociates(this.uuidAccount)
                .then(response => {
                    this.associates = response.data.account_associates;
                })
                .catch(error => console.error(error));
        }
    }
};
